import React from 'react';
import HorizontalStackChart from '../../../../charts/horizontalStackChart';

export const GoalsAndAveragesChart = ({ data, title }) => {
  const maxValue = Math.max(...data.map((item) => item.y), 100);
  return (
    data && data.length > 0 &&
    <div className="chart-container">
      <div className="chart-title">{title}</div>
      <HorizontalStackChart primaryColor="#ff9230" secondaryColor="#595959" data={data}
                            maxValue={maxValue} yLabelFormatter={(datum) => `${datum.y}%`} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/charts/goalsAndAveragesChart.js